export const SHOW_ROUTE_NAMES = {
  LIST: 'show-list',
  DETAIL: 'show-detail',
  EDIT: 'show-edit',
  CREATE: 'show-create',
}
